"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var types_1 = require("@pbl/pbl-react-core/lib/models/ticket/types");
var config_1 = require("@pbl/pbl-react-web-components/lib/config/config");
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var SuperBonusModal_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/ticket-entry/SuperBonusModal"));
var TicketHelpModal_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/ticket-entry/v2/TicketHelpModal"));
var classnames_1 = __importDefault(require("classnames"));
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var react_1 = __importStar(require("react"));
var react_confetti_1 = __importDefault(require("react-confetti"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var constants_1 = __importDefault(require("../../config/constants"));
var TermsOfUseUpdateModal_1 = __importDefault(require("../../modules/SettingsWidget/profile/completeprofile/TermsOfUseUpdateModal"));
var actions_1 = require("../../redux/reducers/activity/actions");
var actions_2 = require("../../redux/reducers/app/actions");
var actions_3 = require("../../redux/reducers/authentication/actions");
var actions_4 = require("../../redux/reducers/draws/actions");
var actions_5 = require("../../redux/reducers/interactive-games/actions");
var actions_6 = require("../../redux/reducers/ledger/actions");
var actions_7 = require("../../redux/reducers/opt-out/actions");
var actions_8 = require("../../redux/reducers/profile/actions");
var actions_9 = require("../../redux/reducers/ticket/actions");
var AnalyticEvents_1 = __importDefault(require("../../utils/AnalyticEvents"));
var framework_1 = require("../../widgets/framework");
var TicketCard_1 = __importDefault(require("./components/TicketCard"));
var styles_2 = __importDefault(require("./styles"));
var TicketHelpModalV2_1 = __importDefault(require("./v2/TicketHelpModalV2"));
var TicketScreen = function (_a) {
    var messageTimeout = _a.messageTimeout, navigateToGames = _a.navigateToGames, resetData = _a.resetData, hideDBGTab = _a.hideDBGTab, _b = _a.withTicketHelpModalDialogTitle, withTicketHelpModalDialogTitle = _b === void 0 ? true : _b, _c = _a.v2, v2 = _c === void 0 ? false : _c, v2Modal = _a.v2Modal, titleComponent = _a.titleComponent, customerVariant = _a.customerVariant;
    var dispatch = (0, react_redux_1.useDispatch)();
    var theme = (0, styles_1.useTheme)();
    var classes = (0, styles_2.default)(theme)();
    var _d = (0, react_1.useState)(false), widgetLoading = _d[0], setWidgetLoading = _d[1];
    var _e = (0, react_1.useState)(false), showSampleTicket = _e[0], setShowSampleTicket = _e[1];
    var _f = (0, react_1.useState)(false), showSuccessModal = _f[0], setShowSuccessModal = _f[1];
    var _g = (0, react_1.useState)(false), showPendingModal = _g[0], setShowPendingModal = _g[1];
    var _h = (0, react_1.useState)(0), pendingPoints = _h[0], setPendingPoints = _h[1];
    var _j = (0, react_1.useState)([]), pendingEntries = _j[0], setPendingEntries = _j[1];
    var _k = (0, react_1.useState)(false), showSuperBonusPopup = _k[0], setShowSuperBonusPopup = _k[1];
    var _l = (0, react_1.useState)(''), initialTab = _l[0], setInitialTab = _l[1];
    var _m = (0, react_1.useState)(config_1.config.internalConfig.TICKET_TABS_DATA[0].tabKey), activeTab = _m[0], setActiveTab = _m[1];
    var _o = (0, react_1.useState)(false), showConfetti = _o[0], setShowConfetti = _o[1];
    var _p = (0, react_1.useState)([]), ticketHelpData = _p[0], setTicketHelpData = _p[1];
    var _q = (0, react_1.useState)(false), showTermsOfUseUpdateModal = _q[0], setShowTermsOfUseUpdateModal = _q[1];
    var _r = (0, react_1.useState)(false), tosChecked = _r[0], setTosChecked = _r[1];
    var _s = (0, react_redux_1.useSelector)(function (state) { return state.authentication; }), isLoggedIn = _s.isAuthenticated, authenticating = _s.authenticating, isRestricted = _s.isRestricted;
    var checkTermsAndConditions = (0, react_redux_1.useSelector)(function (state) { return state.profile; }).checkTermsAndConditions;
    var _t = (0, react_redux_1.useSelector)(function (state) { return state.ticket; }), errorMessage = _t.errorMessage, loading = _t.loading, prizes = _t.prizes, graphicImageUrl = _t.graphicImageUrl, ticketNumber = _t.ticketNumber, validationCode = _t.validationCode, tabKey = _t.tabKey, fastPlayGamesIds = _t.fastPlayGamesIds;
    var draw = (0, react_redux_1.useSelector)(function (state) { return state.drawDetail; }).draw;
    var preferences = (0, react_redux_1.useSelector)(function (state) { return state.optOutPreferences; }).preferences;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _u = (0, react_1.useState)(false), redirectToPromotionDetailsPage = _u[0], setRedirectToPromotionDetailsPage = _u[1];
    var _v = (0, react_1.useState)({}), isEntryOptOut = _v[0], setIsEntryOptOut = _v[1];
    (0, react_1.useEffect)(function () {
        dispatch((0, actions_3.isAuthenticated)());
        dispatch((0, actions_9.fetchGameIdsByGameType)(constants_1.default.FASTPLAY_GAMETYPE_ID));
        return function () {
            dispatch((0, actions_6.resetState)());
            dispatch((0, actions_9.clearPrizes)());
            if (resetData) {
                dispatch((0, actions_9.reset)());
            }
            dispatch((0, actions_9.clearErrors)());
            dispatch((0, actions_2.clearMessages)());
        };
    }, [dispatch, resetData]);
    (0, react_1.useEffect)(function () {
        if (!prizes) {
            return;
        }
        var entryPrizes = prizes.filter(function (prize) {
            return prize.prizeType === types_1.PrizeType.ENTRY && prize.status === 'PENDING';
        });
        var entry = entryPrizes[0];
        var optOutPref = preferences === null || preferences === void 0 ? void 0 : preferences.find(function (p) { var _a; return !!(entry === null || entry === void 0 ? void 0 : entry.draw) && (p === null || p === void 0 ? void 0 : p.drawId) === ((_a = entry === null || entry === void 0 ? void 0 : entry.draw) === null || _a === void 0 ? void 0 : _a.id); });
        if (optOutPref) {
            setIsEntryOptOut(optOutPref);
        }
    }, [prizes, preferences]);
    (0, react_1.useEffect)(function () {
        if (preferences) {
            var entries_1 = prizes === null || prizes === void 0 ? void 0 : prizes.filter(function (x) { return x.prizeType === types_1.PrizeType.ENTRY; });
            if (entries_1 && entries_1.length > 0) {
                var unchangedPreferences = preferences === null || preferences === void 0 ? void 0 : preferences.map(function (pref) {
                    var entry = entries_1.find(function (e) { var _a; return pref.drawId === ((_a = e.draw) === null || _a === void 0 ? void 0 : _a.id); });
                    return __assign(__assign({}, pref), { prizeId: entry === null || entry === void 0 ? void 0 : entry.id });
                });
                optOutChange(unchangedPreferences);
            }
        }
    }, [preferences]);
    (0, react_1.useEffect)(function () {
        if (!isLoggedIn && !authenticating) {
            setWidgetLoading(true);
            redirectToLogin();
        }
        else if (isLoggedIn &&
            !checkTermsAndConditions &&
            constants_1.default.CHECK_TERMS_AND_CONDITIONS_ENABLED) {
            setShowTermsOfUseUpdateModal(true);
        }
    }, [isLoggedIn, authenticating]);
    (0, react_1.useEffect)(function () {
        if (!loading) {
            modalMessage();
            dispatch((0, actions_2.clearLoading)());
        }
    }, [errorMessage, prizes, loading]);
    (0, react_1.useEffect)(function () {
        if (draw && redirectToPromotionDetailsPage) {
            setRedirectToPromotionDetailsPage(false);
            var appNavigate = {
                action: 'PROMOTION_DETAILS',
                data: { id: draw === null || draw === void 0 ? void 0 : draw.promotionId }
            };
            framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
        }
    }, [redirectToPromotionDetailsPage]);
    (0, react_1.useEffect)(function () {
        var test = config_1.config.internalConfig.TICKET_HELP_DATA.filter(function (tab) { return tab.parentTabKey.toLowerCase() === initialTab.toLowerCase(); });
        setTicketHelpData(test);
        if (initialTab !== '') {
            setShowSampleTicket(true);
        }
    }, [initialTab]);
    var redirectToLogin = function () {
        framework_1.GoFwInternalInstance.onHostLogin();
        setWidgetLoading(false);
    };
    var logAnalyticsEvent = function (eventCode, eventLabel, eventCategory) {
        var _a;
        var event = (_a = window === null || window === void 0 ? void 0 : window.analyticsEventMapping) === null || _a === void 0 ? void 0 : _a[eventCode];
        if (!event)
            return;
        AnalyticEvents_1.default.logEvent(eventCode, __assign(__assign({}, event), { eventCategory: eventCategory, eventAction: event.eventAction, eventLabel: eventLabel }));
    };
    var redirectContactUs = function () {
        if (constants_1.default.CUSTOM_CONTACT_US_URL && constants_1.default.CUSTOM_CONTACT_US_URL.length > 0) {
            window.location.href = constants_1.default.CUSTOM_CONTACT_US_URL;
            return;
        }
        var appNavigate = {
            action: 'CONTACT_US'
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    };
    var onSubmitTicket = function (ticketBarcodeNumber, validationNumber, ticketTabKey) { return __awaiter(void 0, void 0, void 0, function () {
        var eventId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, setWidgetLoading(true)];
                case 1:
                    _a.sent();
                    return [4, dispatch((0, actions_9.enterTicket)(ticketBarcodeNumber.toUpperCase(), validationNumber &&
                            (ticketTabKey === undefined || ticketTabKey === '' || ticketTabKey === 'scratchTicket')
                            ? validationNumber.toUpperCase()
                            : '', ticketTabKey, fastPlayGamesIds))];
                case 2:
                    _a.sent();
                    if (!!constants_1.default.SECOND_CHANCE_ONLY) return [3, 4];
                    return [4, dispatch((0, actions_6.fetchUserPoints)())];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [4, dispatch((0, actions_9.fetchDrawsByIds)())];
                case 5:
                    _a.sent();
                    setWidgetLoading(false);
                    eventId = ticketTabKey === 'scratchTicket' ? 'AE0267' : 'AE0268c';
                    logAnalyticsEvent(eventId, 'Submit', ticketTabKey === 'scratchTicket' ? 'submit_ticket_scratch_off' : 'submit_ticket_draw_games');
                    return [2];
            }
        });
    }); };
    var formatDayMonthYearTime = function (date) {
        return (0, moment_timezone_1.default)(date).parseZone().format('MM/DD/YYYY hh:mm A');
    };
    var modalMessage = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (errorMessage == null && prizes !== null && prizes.length > 0) {
            var pendingPointsValue = prizes.filter(function (x) {
                return x.prizeType === types_1.PrizeType.LOYALTY_POINTS && x.status === 'PENDING' && !x.token;
            });
            var pendingDrawEntries = prizes
                .filter(function (x) { return x.prizeType === 'ENTRY' && x.status === 'PENDING'; })
                .map(function (p) { var _a; return ({ pendingEntries: p.amount, drawName: (_a = p.draw) === null || _a === void 0 ? void 0 : _a.name }); });
            if (pendingPointsValue && pendingPointsValue.length > 0 && pendingPointsValue[0].amount) {
                framework_1.GoFwInternalInstance.onEarnActivity();
                setShowPendingModal(true);
                setPendingPoints(pendingPointsValue[0].amount);
            }
            if (pendingDrawEntries && pendingDrawEntries.length > 0) {
                setPendingEntries(pendingDrawEntries);
            }
            if ((!(pendingPointsValue && pendingPointsValue.length > 0) &&
                !(pendingDrawEntries && pendingDrawEntries.length > 0)) ||
                (constants_1.default.HIDE_SUCCESS_FOR_PENDING_ENTRIES &&
                    !(pendingPointsValue && pendingPointsValue.length > 0))) {
                setShowSuccessModal(true);
            }
        }
        else if (errorMessage != null) {
            var errormessage = void 0;
            var errormessageparam = void 0;
            if (((_a = errorMessage.payload.title) === null || _a === void 0 ? void 0 : _a.includes('JACKPOT')) &&
                ((_b = errorMessage.payload.errorKey) === null || _b === void 0 ? void 0 : _b.includes('invalid'))) {
                errormessage = 'error.gameTicketEntry.jackpoterror.invalid';
            }
            else if (errorMessage.payload && !!errorMessage.payload.errorKey) {
                errormessage = errorMessage.payload.errorKey;
                var coolOffTime = ((_c = errorMessage.payload) === null || _c === void 0 ? void 0 : _c.error) ? formatDayMonthYearTime((_d = errorMessage.payload) === null || _d === void 0 ? void 0 : _d.error) : '';
                errormessageparam = { date: coolOffTime };
            }
            else if (!((_e = errorMessage.payload) === null || _e === void 0 ? void 0 : _e.errorKey) && !!((_f = errorMessage.payload) === null || _f === void 0 ? void 0 : _f.title)) {
                errormessage = errorMessage.payload.title;
            }
            else if (!((_g = errorMessage.payload) === null || _g === void 0 ? void 0 : _g.errorKey) && !!((_h = errorMessage.payload) === null || _h === void 0 ? void 0 : _h.error)) {
                errormessage = errorMessage.payload.error;
            }
            else {
                errormessage = (_j = errorMessage.payload) === null || _j === void 0 ? void 0 : _j.errorKey;
            }
            dispatch((0, actions_2.showMessageBar)({ message: errormessage, type: 'error', messageTimeout: messageTimeout, messageParams: errormessageparam }));
        }
    };
    var onDismissSuccessModal = function () { return __awaiter(void 0, void 0, void 0, function () {
        var superBonusEntries, sb, prizeAwarded;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch((0, actions_9.clearErrors)());
                    setShowSuccessModal(false);
                    superBonusEntries = prizes.filter(function (x) {
                        return !!x.superBonuses &&
                            x.superBonuses.length > 0 &&
                            x.superBonuses.filter(function (y) { return y.prizeAwarded; }).length > 0;
                    });
                    if (!(!config_1.config.internalConfig.SHOW_SUPER_BONUS_DIALOG &&
                        !!superBonusEntries &&
                        superBonusEntries.length > 0)) return [3, 3];
                    sb = prizes && prizes[0].superBonuses;
                    prizeAwarded = sb && sb[0].prizeAwarded;
                    if (!(!!superBonusEntries[0].superBonuses && superBonusEntries[0].superBonuses.length > 0)) return [3, 2];
                    return [4, dispatch((0, actions_4.fetchDrawWithAdditionalInformation)(parseInt(superBonusEntries[0].superBonuses[0].externalId, 10)))];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (prizeAwarded) {
                        setShowSuperBonusPopup(true);
                    }
                    return [3, 4];
                case 3:
                    dispatch((0, actions_9.clearPrizes)());
                    _a.label = 4;
                case 4:
                    framework_1.GoFwInternalInstance.onEarnActivity();
                    return [2];
            }
        });
    }); };
    var onDismissSuperBonusModal = function () {
        dispatch((0, actions_9.clearErrors)());
        dispatch((0, actions_9.clearPrizes)());
        setShowSuperBonusPopup(false);
    };
    var onDismissPendingModal = function () {
        dispatch((0, actions_9.clearErrors)());
        dispatch((0, actions_9.clearPrizes)());
        setShowPendingModal(false);
    };
    var showTicketSample = function (ticketType) { return __awaiter(void 0, void 0, void 0, function () {
        var eventId, test;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    eventId = ticketType === 'scratchTicket' ? 'AE0266' : 'AE0268';
                    logAnalyticsEvent(eventId, t('ticket.sampleImageLink'), eventId === 'AE0266' ? 'submit_ticket_scratch_off' : 'submit_ticket_draw_games');
                    return [4, setInitialTab(ticketType)];
                case 1:
                    _a.sent();
                    test = config_1.config.internalConfig.TICKET_HELP_DATA.filter(function (tab) { return tab.parentTabKey.toLowerCase() === initialTab.toLowerCase(); });
                    return [4, setTicketHelpData(test)];
                case 2:
                    _a.sent();
                    setShowSampleTicket(true);
                    return [2];
            }
        });
    }); };
    var onDismissSampleModal = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            logAnalyticsEvent('AE0163', 'ok', 'ticket_checker');
            setShowSampleTicket(false);
            return [2];
        });
    }); };
    var getGameData = function (digitalRevealToken) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, dispatch((0, actions_5.startGame)(digitalRevealToken))];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var gameEnded = function (digitalRevealToken) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, dispatch((0, actions_5.endGame)(digitalRevealToken))];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var gameSkipped = function (digitalRevealToken) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, dispatch((0, actions_5.skipGame)(digitalRevealToken))];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var startDigitalGame = function (digitalRevealToken) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, dispatch((0, actions_5.startGame)(digitalRevealToken))];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var optOutChange = function (args) {
        if (args)
            dispatch((0, actions_7.optOut)(args));
    };
    var onViewSuperBonusProgress = function () { return __awaiter(void 0, void 0, void 0, function () {
        var sb, superBonusKey, activity, appNavigate;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    sb = prizes && prizes[0].superBonuses;
                    superBonusKey = sb && sb[0].superBonusKey;
                    if (!!!superBonusKey) return [3, 2];
                    return [4, (0, actions_1.getActivityByKey)(superBonusKey, isLoggedIn)];
                case 1:
                    activity = _a.sent();
                    appNavigate = {
                        action: 'ACTIVITY_DETAILS',
                        data: activity
                    };
                    framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
                    onDismissSuccessModal();
                    _a.label = 2;
                case 2: return [2];
            }
        });
    }); };
    var displayConfetti = function (value) {
        setShowConfetti(value);
    };
    var onSubmitTos = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, dispatch((0, actions_8.updateTermsAndConditions)())];
                case 1:
                    _a.sent();
                    return [4, dispatch((0, actions_8.fetchTermsAndConditions)())];
                case 2:
                    _a.sent();
                    setShowTermsOfUseUpdateModal(false);
                    return [2];
            }
        });
    }); };
    var handleTosChecked = function () {
        setTosChecked(!tosChecked);
    };
    var onOpenDrawDetails = function (promotionId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, dispatch((0, actions_4.fetchDrawWithAdditionalInformation)(Number(promotionId)))];
                case 1:
                    _a.sent();
                    setRedirectToPromotionDetailsPage(true);
                    return [2];
            }
        });
    }); };
    var onTabChange = function (ticketType) {
        setActiveTab(ticketType);
    };
    if (widgetLoading || !isLoggedIn) {
        return react_1.default.createElement(package_1.AppSpinner, { label: 'Loading...' });
    }
    var handleTabChangeAnalytics = function (tabTitle) {
        logAnalyticsEvent('AE0162', t(tabTitle), 'ticket_checker');
    };
    var handleOnBlurAnalytics = function (fieldKey) {
        var eventId = fieldKey === 'ticketNumber'
            ? 'AE0265'
            : fieldKey === 'validationCode'
                ? 'AE0265b'
                : 'AE0267b';
        var eventLabel = fieldKey === 'ticketNumber'
            ? 'TicketTextBox'
            : fieldKey === 'validationCode'
                ? 'EntryCodeTextBox'
                : 'drawEntryCodeTextBox';
        var eventCategory = eventId === 'AE0265' || eventId === 'AE0265b'
            ? 'submit_ticket_scratch_off'
            : 'submit_ticket_draw_games';
        logAnalyticsEvent(eventId, eventLabel, eventCategory);
    };
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(Grid_1.default, { container: true, className: (0, classnames_1.default)(classes.ticketContainer, classes.center) },
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 12, md: 12, lg: constants_1.default.SHOW_TICKETCARDVIEW ? 12 : 6, xl: constants_1.default.SHOW_TICKETCARDVIEW ? 12 : 6 },
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(package_1.TicketPendingModal, { onDismiss: onDismissPendingModal, showSuccessModal: showPendingModal && !showSuccessModal, pendingPoints: pendingPoints || 0, drawProps: pendingEntries }),
                    react_1.default.createElement(package_1.TicketValidatedModal, { onDismiss: onDismissSuccessModal, showSuccessModal: showSuccessModal, prizes: prizes, graphicImageUrl: graphicImageUrl, getGameData: getGameData, startGame: startDigitalGame, endGame: gameEnded, skipGame: gameSkipped, showTicketDisclaimer: constants_1.default.SHOW_TICKETDISCLAIMER, navigateToSuperBonusDetails: config_1.config.internalConfig.SHOW_SUPER_BONUS_DIALOG ? onViewSuperBonusProgress : function () { }, displayConfetti: displayConfetti, showDigitalRevealSummaryOnEnd: config_1.config.internalConfig.SHOW_SUPER_BONUS_DIALOG
                            ? constants_1.default.SHOW_DIGITAL_SUMMARY_AT_END
                            : undefined, onOptOut: optOutChange, optOutPreferences: preferences, onOpenDrawDetails: onOpenDrawDetails, isEntryOptOut: isEntryOptOut }),
                    showConfetti && (react_1.default.createElement(react_confetti_1.default, { style: { zIndex: 1301 }, tweenDuration: 3000, numberOfPieces: 1500, width: window.innerWidth, height: document.body.scrollHeight })),
                    showSampleTicket && (react_1.default.createElement(react_1.default.Fragment, null, (v2Modal !== null && v2Modal !== void 0 ? v2Modal : v2) ? (react_1.default.createElement(TicketHelpModalV2_1.default, { visible: showSampleTicket, onDismiss: onDismissSampleModal, initialTabKey: initialTab, displayVideo: false, tabs: ticketHelpData, withDialogTitle: withTicketHelpModalDialogTitle })) : (react_1.default.createElement(TicketHelpModal_1.default, { visible: showSampleTicket, onDismiss: onDismissSampleModal, initialTabKey: initialTab, displayVideo: false, tabs: ticketHelpData, withDialogTitle: withTicketHelpModalDialogTitle, handleButtonChangeAnalytics: handleTabChangeAnalytics })))),
                    react_1.default.createElement(Typography_1.default, { variant: constants_1.default.V2_CHANGES ? 'h2' : 'h4', component: titleComponent || 'h2', gutterBottom: true, color: 'textPrimary', style: {
                            textAlign: 'center',
                            marginBottom: theme.spacing(5)
                        } }, constants_1.default.V2_CHANGES ? 'Submit Ticket' : 'Enter Ticket'),
                    react_1.default.createElement(TicketCard_1.default, { v2: v2, loading: loading, showSampleTicket: showTicketSample, onTicketSubmit: onSubmitTicket, showTicketCardView: constants_1.default.SHOW_TICKETCARDVIEW, successfulEntered: showPendingModal || showSuccessModal, showSampleTicketHelpImage: showTicketSample, theme: theme, navigateToGames: navigateToGames, ticketNumber: ticketNumber, validationCode: validationCode, tabKey: tabKey, isRestricted: isLoggedIn && isRestricted, hideDBGTab: hideDBGTab, handleContactUs: redirectContactUs, setActiveTabKey: onTabChange, activeTabKey: activeTab, customerVariant: customerVariant, handleOnBlurAnalytics: handleOnBlurAnalytics }),
                    config_1.config.internalConfig.SHOW_SUPER_BONUS_DIALOG ? null : (react_1.default.createElement(SuperBonusModal_1.default, { isVisible: showSuperBonusPopup, prizes: prizes, draw: draw, onClose: onDismissSuperBonusModal })),
                    react_1.default.createElement(TermsOfUseUpdateModal_1.default, { show: showTermsOfUseUpdateModal, tosChecked: tosChecked, onSubmitTos: onSubmitTos, handleTosChecked: handleTosChecked }))))));
};
exports.default = TicketScreen;
//# sourceMappingURL=index.js.map